import React from "react";
import ReactAnimatedWeather from "react-animated-weather";
import "./WeatherForecast.css";

export default function WeatherIcon(props) {
    const codeMapping = {
        "clear-sky-day": "CLEAR_DAY",
        "clear-sky-night": "CLEAR_NIGHT",
        "few-clouds-day": "CLOUDY",
        "few-clouds-night": "CLOUDY",
        "scattered-clouds-day": "CLOUDY",
        "scattered-clouds-night": "CLOUDY",
        "broken-clouds-day": "PARTLY_CLOUDY_DAY",
        "broken-clouds-night": "PARTLY_CLOUDY_NIGHT",
        "shower-rain-day": "RAIN",
        "shower-rain-night": "RAIN",
        "rain-day": "RAIN",
        "rain-night": "RAIN",
        "thunderstorm-day": "RAIN",
        "thunderstorm-night": "RAIN",
        "snow-day": "SNOW",
        "snow-night": "SNOW",
        "mist-day": "FOG",
        "mist-night": "FOG",
      };
    
        return (
        <ReactAnimatedWeather
        icon={codeMapping[props.code]}
        color={"#360f66"}
        size={props.size}
        animate={true}
      />
      );
    }
    
